import posthog from 'posthog-js'

/**
 * @warning This module can only be used on the client side as it depends on posthog-js.
 * Do not import this in server-side code or server components.
 */

/**
 * Captures an analytics event with the given event name and optional properties.
 * This can only be used in client-side code (e.g. event handlers, useEffect, client components).
 *
 * @example
 * // Basic usage
 * track('button clicked')
 *
 * // With properties
 * track('form submitted', {
 *   formId: 'contact',
 *   source: 'homepage'
 * })
 */
export function track(event: string, properties: Record<string, unknown> = {}) {
	posthog.capture(event, {
		...properties,
		path: window.location.pathname,
	})
}

/**
 * Resets the PostHog tracking state.
 * This should be called when a user logs out to ensure their future actions
 * are not associated with their previous identity.
 */
export function resetTracking() {
	posthog.reset()
}
